import { render, staticRenderFns } from "./predeterStudent.vue?vue&type=template&id=3ce00adc&scoped=true&"
import script from "./predeterStudent.vue?vue&type=script&lang=js&"
export * from "./predeterStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce00adc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce00adc')) {
      api.createRecord('3ce00adc', component.options)
    } else {
      api.reload('3ce00adc', component.options)
    }
    module.hot.accept("./predeterStudent.vue?vue&type=template&id=3ce00adc&scoped=true&", function () {
      api.rerender('3ce00adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionAllController/predeterStudent.vue"
export default component.exports